import Vue from 'vue';

export default {
    state: Vue.observable({
        user: {},
        signedIn: false,
        signUp: {
            email: false,
            regionId: false,
            cityId: false
        },
    }),
    setUser(user) {
        this.state.user = user;
    },
    setSignedIn(signedIn) {
        this.state.signedIn = signedIn;
    },
    setSignUpEmail(email) {
        this.state.signUp.email = email;
    },
    setSignUpRegionId(id) {
        this.state.signUp.regionId = id;
    },
    setSignUpCityId(id) {
        this.state.signUp.cityId = id;
    },
};
